import * as React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import ProfileAmountCard, { ProfileWallet } from './ProfileAmountCard';
import ProfileSettings from '../../blocks/form/ProfileSettings';
import AccountSettings from '../../blocks/form/AccountSettings';
import DateTimePickerForm from '../../blocks/form/DateTimePickerForm';
import PaymentMethod from '../../element/card/PaymentMethod';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

 const ProfileTabs = () => {
    
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ maxWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        aria-label="Vertical tabs with icons"
                        sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                            flexShrink: 0,
                            width: '356px',
                            height: '291px',
                            backgroundColor: '#F4F4F4',
                            border: '0.5px solid #28A745',
                            '& .MuiTab-root': {
                                paddingLeft: '6px',
                            },
                            '& .MuiTabs-indicator': {
                                display: 'none',
                            },
                            '& .MuiTab-root.Mui-selected': {
                                borderLeft: '4px solidrgb(163, 228, 155)',
                            },
                        }}
                    >
                        <Tab label="dashboard" {...a11yProps(0)} />
                        <Tab label="Wallet"  {...a11yProps(1)} />
                        <Tab label="Profile Settings"  {...a11yProps(2)} />
                        <Tab label="Account Settings"  {...a11yProps(3)} />
                        <Tab label="Payment Settings" {...a11yProps(4)} />

                    </Tabs>
                    <PaymentMethod/>
                </Box>


                <Box sx={{ flexGrow: 1, height: '100%' }} >
                    <TabPanel value={value} index={0}>
                        <ProfileAmountCard />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <ProfileWallet />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <ProfileSettings />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <AccountSettings />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <DateTimePickerForm />
                    </TabPanel>

                </Box>
            </Box>
        </Box>
    );
}
export default ProfileTabs;